/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type RemoveItemsFromHardwareRequestMutationVariables = Types.Exact<{
  request_id: Types.Scalars["Float"];
  item_ids: Array<Types.Scalars["Int"]> | Types.Scalars["Int"];
}>;

export type RemoveItemsFromHardwareRequestMutation = {
  removeItemsFromHardwareRequest: Pick<Types.Success, "status">;
};

export const RemoveItemsFromHardwareRequestDocument = gql`
  mutation RemoveItemsFromHardwareRequest(
    $request_id: Float!
    $item_ids: [Int!]!
  ) {
    removeItemsFromHardwareRequest(
      request_id: $request_id
      item_ids: $item_ids
    ) {
      status
    }
  }
`;

/**
 * __useRemoveItemsFromHardwareRequestMutation__
 *
 * To run a mutation, you first call `useRemoveItemsFromHardwareRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemsFromHardwareRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemsFromHardwareRequestMutation, { data, loading, error }] = useRemoveItemsFromHardwareRequestMutation({
 *   variables: {
 *      request_id: // value for 'request_id'
 *      item_ids: // value for 'item_ids'
 *   },
 * });
 */
export function useRemoveItemsFromHardwareRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveItemsFromHardwareRequestMutation,
    RemoveItemsFromHardwareRequestMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    RemoveItemsFromHardwareRequestMutation,
    RemoveItemsFromHardwareRequestMutationVariables
  >(RemoveItemsFromHardwareRequestDocument, baseOptions);
}
export type RemoveItemsFromHardwareRequestMutationHookResult = ReturnType<
  typeof useRemoveItemsFromHardwareRequestMutation
>;
export type RemoveItemsFromHardwareRequestMutationResult =
  ApolloReactCommon.MutationResult<RemoveItemsFromHardwareRequestMutation>;
export type RemoveItemsFromHardwareRequestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RemoveItemsFromHardwareRequestMutation,
    RemoveItemsFromHardwareRequestMutationVariables
  >;
